import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import atGift2025_1Avif from '@/assets/images/at_gift_2025_1.avif';
import atGift2025_2Avif from '@/assets/images/at_gift_2025_2.avif';
import atGift2025LogoAvif from '@/assets/images/at_gift_2025_logo.avif';
import styles from './styles/styles.module.scss';

export const GC_2025_LOGO = 'gc-2025-logo';
export const GC_2025_1 = 'gc-2025-1';
export const GC_2025_2 = 'gc-2025-2';

export type GiftCardVariants = typeof GC_2025_LOGO | typeof GC_2025_1 | typeof GC_2025_2;

type GiftCardProps = {
  variant: GiftCardVariants;
  className?: string;
};

const GiftCard = ({ variant, className }: GiftCardProps) => {
  const intl = useIntl();

  if (variant === GC_2025_1) {
    return (
      <div className={classNames(styles.gc, className)}>
        <Image src={atGift2025_1Avif} alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} />
      </div>
    );
  }

  if (variant === GC_2025_2) {
    return (
      <div className={classNames(styles.gc, className)}>
        <Image src={atGift2025_2Avif} alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} />
      </div>
    );
  }

  return (
    <div className={classNames(styles.gc, className)}>
      <Image src={atGift2025LogoAvif} alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} />
    </div>
  );
};

export default GiftCard;
